import { useEffect } from "react"
import { useAddress } from "@/hooks/wallet"

export const useSetAllItems = <T>({
  items,
  setAllItems,
}: {
  items: (T | undefined)[]
  setAllItems: (items: T[], currentAddress?: string) => void
}) => {
  const address = useAddress()
  useEffect(() => {
    const validItems = items.flatMap(item => (item ? [item] : []))

    setAllItems(validItems, address)
  }, [items, setAllItems, address])
}
